import React, {ButtonHTMLAttributes, FC} from 'react';

import type {ButtonModel} from '@/types/aem/buttonModel';

import {AppButton} from '../Button';
import RemoteIconV2 from '../Icon/RemoteIconV2';

type AemButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    iconPath?: string;
    textClassName?: string;
    primary?: boolean;
    // TODO: add other props if needed
    [key: string]: any;
} & Partial<ButtonModel>;

const AemButton: FC<AemButtonProps> = ({alt, iconPath, icon, text, className, textClassName, children, ...rest}) => {
    if (!iconPath && !text && !icon) return null;

    return (
        <AppButton type='button' className={className} {...rest}>
            <div className='flex items-center justify-center gap-2'>
                <div className={textClassName}>{text}</div>
                {/*@ts-ignore*/}
                <RemoteIconV2 icon={icon || {path: iconPath, alt}} />
                {children}
            </div>
        </AppButton>
    );
};

export default AemButton;
